










































import { Component, Mixins } from 'vue-property-decorator'
import BasePage from '@/tcw/components/BasePage'
import Getsudo from '@/tcw/domain/Getsudo'
import FormStoreComponent from '@/tcw/components/FormStoreComponent'
import TcwLayoutBasicTemplate from '@/layout/TcwLayoutBasicTemplate.vue'
import { teishutsuInputStore } from '@/store/form/TeishutsuInputFormStore'
import TeishutsuInputForm from '../organisms/TeishutsuInputForm.vue'
import ShouninRouteSteps from '@/components/settei/organisms/ShouninRouteSteps.vue'

@Component({
  components: {
    TcwLayoutBasicTemplate,
    TeishutsuInputForm,
    ShouninRouteSteps
  }
})
export default class TeishutsuInputPage extends Mixins(BasePage) {
  protected targetGetsudo: Getsudo | null = null
  protected get form(): FormStoreComponent {
    return this.$refs.form as FormStoreComponent
  }

  protected created(): void {
    if (this.routeParams.year && this.routeParams.month) {
      // URLパラメータに月度が指定されていた場合(承認対象者の提出情報を確認する場合)
      this.targetGetsudo = Getsudo.of(this.routeParams.year, this.routeParams.month)
    } else {
      // 月度未指定の場合
      this.targetGetsudo = this.currentGetsudo
    }
  }

  protected save(): void {
    this.form.startSaveProc()
  }
  get hasTeishutsu(): boolean {
    return !teishutsuInputStore.isNewRecord
  }
  get updateTypeStr(): string {
    return this.hasTeishutsu ? '更新' : '登録'
  }
}
